import React, { createContext, useContext, useEffect, useState } from "react";
import { API_BASE_URL } from "../utils/app_url";

const SiteDataContext = createContext();

export const useSiteData = () => useContext(SiteDataContext);

export const SiteDataProvider = ({ children }) => {
    const [categories, setCategories] = useState([]);
    const [announcements, setAnnouncements] = useState([]);
    const [configs, setConfigs] = useState({});

    useEffect(() => {
        // Fetch categories
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}products/categories`);
                const data = await response.json();
                if (data && Array.isArray(data.data)) {
                    setCategories(data.data);
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        // Fetch announcements
        const fetchAnnouncements = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}frontend/site-announcements`);
                const data = await response.json();
                if (data.res === true && Array.isArray(data.data)) {
                    setAnnouncements(data.data);
                }
            } catch (error) {
                console.error("Error fetching announcements:", error);
            }
        };

        // Fetch configs
        const fetchConfigs = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}frontend/configs`);
                const data = await response.json();
                if (data.res === true && typeof data.data === "object") {
                    setConfigs(data.data);
                }
            } catch (error) {
                console.error("Error fetching configs:", error);
            }
        };

        fetchCategories();
        fetchAnnouncements();
        fetchConfigs();
    }, []);

    return (
        <SiteDataContext.Provider value={{ categories, announcements, configs }}>
            {children}
        </SiteDataContext.Provider>
    );
};
